import { JSONSchema4 } from 'json-schema';
import ContentSchema from './Content.json';
import CLSchema from './CL.json';

// Change from type to const enum for better TypeScript support
export const enum CourseType {
  FullCourse = 'Full Course',
  ConversationalLearning = 'Conversational Learning'
}

// Use the enum values for type safety
const schemaRegistry = new Map<CourseType, JSONSchema4>([
  [CourseType.FullCourse, ContentSchema as JSONSchema4],
  [CourseType.ConversationalLearning, CLSchema as JSONSchema4]
]);

export const getSchemaForActivity = (activityType: CourseType): JSONSchema4 => {
  const schema = schemaRegistry.get(activityType);
  if (!schema) {
    throw new Error(`No schema found for activity type: ${activityType}`);
  }
  return schema;
};

export const updateMonacoSchema = (activityType: CourseType) => {
  const schema = getSchemaForActivity(activityType);
  return {
    uri: 'http://myserver/content-schema.json',
    fileMatch: ['*.yaml', '*.yml'],
    schema
  };
};
